const ATTRIBUTION_WINDOW_MS = 1000

// Reveal doesn't report what triggered a navigation, so remember the last
// input and only trust it if the slide change follows promptly.
export default class NavigationSource {
  constructor(element) {
    this.element = element
    this.keydown = () => this.mark('keyboard')
    this.pointerdown = (event) => {
      this.mark(event.target.closest('.controls') ? 'button' : 'slide')
    }

    document.addEventListener('keydown', this.keydown)
    this.element.addEventListener('pointerdown', this.pointerdown, true)
  }

  stop() {
    document.removeEventListener('keydown', this.keydown)
    this.element.removeEventListener('pointerdown', this.pointerdown, true)
  }

  mark(source) {
    this.last = { source, at: Date.now() }
  }

  consume() {
    if (!this.last) return 'other'

    const { source, at } = this.last
    this.last = null

    return Date.now() - at < ATTRIBUTION_WINDOW_MS ? source : 'other'
  }
}
